export enum PpkTaxModeType {
  CurrentMonth = 0,
  NextMonth = 1,
}
